var map = {
	"./arrow-thick.svg": "62a5",
	"./barcode.svg": "5773",
	"./bars.svg": "82fd",
	"./calendar.svg": "6bca",
	"./caret-down.svg": "26de",
	"./caret-left.svg": "de9c",
	"./caret-right.svg": "aeba",
	"./caret-up.svg": "8dac",
	"./chart-bar.svg": "560c",
	"./chart.svg": "ef55",
	"./chevron-down.svg": "c963",
	"./chevron-left.svg": "dc03",
	"./chevron-right.svg": "5046",
	"./chevron-up.svg": "ed78",
	"./comment-exclamation.svg": "4b12",
	"./comment.svg": "3ef7",
	"./copy-icon.svg": "2d02",
	"./ellipsis-h.svg": "574e",
	"./error.svg": "7ea5",
	"./flag.svg": "0f00",
	"./fullscreen-exit.svg": "ce9d",
	"./fullscreen.svg": "3dd2",
	"./label-printer.svg": "50d5",
	"./list-alt.svg": "ae5d",
	"./list.svg": "a93e",
	"./lock-locked.svg": "292e",
	"./lock-unlocked.svg": "e5e3",
	"./lock.svg": "7529",
	"./logout.svg": "c5d0",
	"./parcels.svg": "a04c",
	"./products.svg": "f68d",
	"./punchclock.svg": "175b",
	"./redo.svg": "f76f",
	"./salary.svg": "1f4d",
	"./search.svg": "f919",
	"./serial-number.svg": "2bed",
	"./settings.svg": "e15e",
	"./speedometer.svg": "185d",
	"./stopwatch-alt.svg": "3b53",
	"./stopwatch.svg": "ea88",
	"./stopwatch2.svg": "c719",
	"./trophy.svg": "771c",
	"./user.svg": "afa4",
	"./users.svg": "0b2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";